var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('CardInfo'),_c('FilmList',{attrs:{"has-card":_vm.hasCard,"card":_vm.card,"type":"report"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }